import React from "react";

const UserSuggestionsDropdown = ({ 
  suggestions, 
  onSelectUser, 
  onClose 
}) => {
  return (
    <div className="absolute z-10 w-full mt-1 overflow-auto bg-white border rounded-lg shadow-lg border-gray border-opacity-35 max-h-60">
      <ul>
        {suggestions.map((user, index) => (
          <li 
            key={`suggestion-${index}`}
            className="p-2 cursor-pointer font-itcbook hover:bg-gray hover:bg-opacity-35"
            onClick={() => {
              onSelectUser(user);
              onClose();
            }}
          >
            {user.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserSuggestionsDropdown;